"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Form.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : SelectFormSide.js
* Description : Ce fichier contient la définition du composant SelectFormSide 
*               Ce composant est une liste déroulante sur le coté de la page pour sélectionner un élément dans une liste 
*               afin de remplir un formulaire 
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* InputForm : affiche une liste déroulante pour sélectionner un élément dans une liste afin de remplir un formulaire 
*             avec une dimension adaptée pour un affichage sur le coté de la page
*
* Type : composant 
*
* Parametres : 
*  - error -- booléen pour remonter une erreur de validation de la sélection
*  - labelText -- texte affiché au dessus de la liste déroulante pour apporter des précisions
*  - choices -- liste des éléments présents dans la liste déroulante
*  - choiceParam -- paramètre à utiliser pour afficher les élements de la liste
*  - selectedItem -- élément sélectionnée
*  - setSelectedItem -- fonction pour mettre à jour la variable selectedItem
*/function SelectFormSide(_ref) {
  var error = _ref.error,
    labelText = _ref.labelText,
    choices = _ref.choices,
    choiceParam = _ref.choiceParam,
    selectedItem = _ref.selectedItem,
    setSelectedItem = _ref.setSelectedItem;
  return error ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "select-form-side",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "select-form-label",
      children: [labelText, " :"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
      name: "selectedChoice",
      className: "select-form-side-error",
      value: selectedItem,
      onChange: function onChange(e) {
        return setSelectedItem(e.target.value);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: 0,
        children: '--Tous--'
      }), choices.map(function (choice) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: choice['id'],
          children: choice[choiceParam]
        }, choice['id']);
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "form-error",
      children: "Ce champ est obligatoire !"
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "select-form-side",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "select-form-label",
      children: [labelText, " :"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
      name: "selectedChoice",
      className: "select-form-side-option",
      value: selectedItem,
      onChange: function onChange(e) {
        return setSelectedItem(e.target.value);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
        value: 0,
        children: '--Tous--'
      }), choices.map(function (choice) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: choice['id'],
          children: choice[choiceParam]
        }, choice['id']);
      })]
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
SelectFormSide.propTypes = {
  error: _propTypes["default"].bool,
  labelText: _propTypes["default"].string,
  choices: _propTypes["default"].array,
  selectedItem: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  setSelectedItem: _propTypes["default"].func
};
var _default = exports["default"] = SelectFormSide;